import { useMediaQuery } from 'react-responsive';

const useIsTouchScreen = () => {
    const isCoarse = useMediaQuery({ query: '(pointer: coarse)' });
    return isCoarse;
    // const isTouch = (navigator?.maxTouchPoints ?? 0) > 1;
    // return isCoarse || isTouch;
};

export default useIsTouchScreen;
